<div class="card">
<div class="flex items-center justify-center min-h-screen bg-gray-100">
    <div class="bg-white shadow-lg rounded-2xl p-6 w-96 relative">

      <div class="relative flex justify-center">
        <div class="rfid-icon">
          <div class="wave"></div>
          <div class="wave delay-1"></div>
          <div class="wave delay-2"></div>
          <div class="rfid-chip">
            <i class="fas fa-wifi text-white text-xl"></i>
          </div>
        </div>
      </div>




<div class="rfid-listner">

    <input
    #rfidInput
    type="text"
    id="rfid-input"
    (keydown)="onRFIDKeydown($event)"

    autocomplete="off"/>
</div>


</div>
</div>
